<template>
  <Notification />
</template>

<script>
import Notification from "@/components/notifications/Notification.vue";

export default {
  name: "NotificationPage",
  components: { Notification },
};
</script>
